import { useOfficeTranslation } from "i18n/OfficeTranslation";
import { DashboardWidgetInstance } from "models/Dashboard";
import React from "react";
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { DashboardWidgetDefinition } from "./widgetRegistry";

interface Props {
    definition: DashboardWidgetDefinition | null;
    open: boolean;
    widget: DashboardWidgetInstance | null;
    onChange: (widget: DashboardWidgetInstance) => void;
    onClose: () => void;
}

const DashboardWidgetSettingsModal: React.FC<Props> = ({ definition, open, widget, onChange, onClose }) => {
    const { t } = useOfficeTranslation();
    if (!definition || !widget) return null;
    const changeSetting = (key: string, value: number) => onChange({
        ...widget,
        settings: { ...widget.settings, [key]: value },
    });

    return <Modal isOpen={open} toggle={onClose} centered>
        <ModalHeader toggle={onClose}>{t("dashboard.editor.configureWidget", { name: t(definition.titleKey) })}</ModalHeader>
        <ModalBody>
            {definition.settings.length === 0
                ? <p className="text-muted">{t("dashboard.editor.noSettings")}</p>
                : definition.settings.map(field => {
                    const inputID = `dashboard-setting-${field.key}`;
                    const value = widget.settings[field.key] ?? field.defaultValue;
                    return <div className="mb-3" key={field.key}>
                        <Label for={inputID}>{t(field.labelKey)}</Label>
                        {field.options
                            ? <Input
                                id={inputID}
                                type="select"
                                value={value}
                                onChange={event => changeSetting(field.key, Number(event.target.value))}
                            >
                                {field.options.map(option => <option key={option.value} value={option.value}>
                                    {t(option.labelKey)}
                                </option>)}
                            </Input>
                            : <Input
                                id={inputID}
                                type="number"
                                min={field.minimum}
                                max={field.maximum}
                                value={value}
                                onChange={event => changeSetting(field.key, Math.min(field.maximum, Math.max(field.minimum, Number(event.target.value))))}
                            />}
                    </div>;
                })}
        </ModalBody>
        <ModalFooter><Button color="primary" type="button" onClick={onClose}>{t("common.close")}</Button></ModalFooter>
    </Modal>;
};

export default DashboardWidgetSettingsModal;
